import { combineReducers } from '@ngrx/store';

import { homeItemDetailReducer as homeItemDetail } from '@home-item-detail/store/reducers/home-item-detail.reducer';
import { recentFlightOfferReducer as flightOffers } from '@home-item-detail/store/reducers/flight-offers.reducer';
import { UiHomeItemDetailRootReducer as ui } from './ux';

export const homeItemDetailRootReducer = combineReducers({
  homeItemDetail,
  ui,
  flightOffers
});
